export default {
  methods: {
    showModal() {
      this.$store.commit('modals/SET_SHOW_ENQUIRY_MODAL', true);


window.dataLayer = window.dataLayer || [];
window.dataLayer.push({
 'event': 'showenquirymodal'
 });

    },
  },

  render() {
    return this.$scopedSlots.default({
      showModal: this.showModal,
    });
  },
};
